import React from "react";
import dynamic from "next/dynamic";
import Head from "next/head";

import jobs from "@/data/careers/jobs.json";
import SeoMetaData from "@/components/utils/seo-metadata";
import seoData from "@/data/seo/page-data.json";

const JobDetails = dynamic(() => import("@/components/careers/job-details"), {
  ssr: false,
});

const JobDetailsPage = ({ id }: any) => {
  return (
    <>
      <Head>
        <title>{seoData.CAREERS_JOBS_WITH_ID.title}</title>
        <SeoMetaData data={seoData.CAREERS_JOBS_WITH_ID} />
      </Head>

      <JobDetails jobId={id} />
    </>
  );
};

export async function getStaticPaths() {
  // Enumerate every job id from the local data — output:"export" needs the full
  // path set (fallback:false); unknown ids 404 until the next rebuild.
  const paths = jobs.map((job: any) => ({
    params: { id: `${job.id}` },
  }));

  return { paths, fallback: false };
}

export async function getStaticProps({ params }: any) {
  return { props: { id: params.id } };
}

export default JobDetailsPage;
